<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'COMMUNITIES', url: '/admin/communities' },
    { label: 'UPDATE_COMMUNITY' }
  ]"
></breadcrumbs>

<page-header title="UPDATE_COMMUNITY"></page-header>

<card>
  <form autocomplete="off" class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="NAME">{{
        'NAME' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="name"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['name'])"
          [ngClass]="{ 'is-danger': hasError('name') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('name')">
        {{ getError('name') }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped px-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      translationEditableDirective="SUBMIT"
      (click)="onSubmit($event)"
    >
      {{ 'SUBMIT' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin/communities']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>
